import { useEffect } from 'react';

const LOADED_FLAG = '__app_loaded__';

export function useResetSessionCache(key: string) {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const alreadyLoaded = sessionStorage.getItem(LOADED_FLAG) === '1';

    if (alreadyLoaded) {
      sessionStorage.removeItem(key);
    }

    sessionStorage.setItem(LOADED_FLAG, '1');
  }, [key]);
}
